module.exports = __webpack_public_path__ + "img/help.5eb86fb1.svg";